// src/components/RouteScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that automatically scrolls to the top of the page when the route changes.
 * This ensures users always start at the top when navigating to a new page.
 */
const RouteScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant', // Use 'instant' for immediate scroll without animation
    });
  }, [pathname]);

  return null; // This component doesn't render anything
};

export default RouteScrollToTop;

